import { render, staticRenderFns } from "./PortabilityRequestDetails.vue?vue&type=template&id=5cf9e690&scoped=true"
import script from "./PortabilityRequestDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./PortabilityRequestDetails.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PortabilityRequestDetails.vue?vue&type=style&index=0&id=5cf9e690&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf9e690",
  null
  
)

export default component.exports